import React from 'react';
import { motion } from 'framer-motion';

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col items-center gap-10"
    >
      {/* Title centered at the top */}
      <h2 className="text-3xl md:text-4xl font-bold text-center">Skills</h2>

      {/* Two columns below */}
      <div className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20">
        {/* Left Column */}
        <div className="w-full lgl:w-1/2 flex flex-col gap-6">
          {[
            { name: 'Canva Design (Posters, Reels, Stories)', percent: 90 },
            { name: 'Adobe Photoshop (Editing, Flyers, Mockups)', percent: 85 },
            { name: 'Logo & Banner Design', percent: 80 },
            { name: 'Social Media Creatives', percent: 85 },
          ].map((skill, index) => (
            <div className="overflow-x-hidden" key={index}>
              <p className="text-sm uppercase font-medium">{skill.name}</p>
              <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
                <motion.span
                  initial={{ x: "-100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  style={{ width: `${skill.percent}%` }}
                  className="block h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
                >
                  <span className="absolute -top-7 right-0">{skill.percent}%</span>
                </motion.span>
              </span>
            </div>
          ))}
        </div>

        {/* Right Column */}
        <div className="w-full lgl:w-1/2 flex flex-col gap-6">
          {[
            { name: 'Color Theory & Typography Basics', percent: 80 },
            { name: 'Basic Video Thumbnails & Covers', percent: 75 },
            { name: 'Fast Learner', percent: 95 },
            { name: 'Deadline-Oriented & Team Collaboration', percent: 90 },
          ].map((skill, index) => (
            <div className="overflow-x-hidden" key={index}>
              <p className="text-sm uppercase font-medium">{skill.name}</p>
              <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
                <motion.span
                  initial={{ x: "-100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  style={{ width: `${skill.percent}%` }}
                  className="block h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
                >
                  <span className="absolute -top-7 right-0">{skill.percent}%</span>
                </motion.span>


              </span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Skills;
